import { InputSearch } from "../components/InputSearch"

export const SearchScreen = () => {
  return (
    <div>
        <InputSearch/>
    </div>
  )
}
